// Future - could import this from some helper to share it across other packages in this repo
// taken from here: https://www.davedrinks.coffee/how-do-i-use-two-react-refs/
export const mergeRefs = (...refs) => {
  const filteredRefs = refs.filter(Boolean);
  // no valid refs
  if (!filteredRefs.length) {
    return null;
  }
  // only 1 ref, nothing to merge so pass it through
  if (filteredRefs.length === 1) {
    return filteredRefs[0];
  }
  // return a callback ref that assigns the instance to the multiple input refs
  return instance => {
    for (const ref of filteredRefs) {
      if (typeof ref === 'function') {
        ref(instance);
      } else {
        ref.current = instance;
      }
    }
  };
};

